export default __webpack_public_path__ + "static/media/homepage_5.3c74d9bf.png";